<template>
  <a-card class="todo-container" :bordered="false" :body-style="{padding: '10px'}" :title="$t('message.views.workbench.toInbound')">
    <a-table :columns="toInboundColumn" :data-source="toInboundData" size="small" :bordered="false" :pagination="toInboundPagination" @change="getInboundOrders">
      <a slot="orderCode" slot-scope="text, record" @click="showOrderDetail(record)"><a-tooltip placement="topLeft" :title="record.purchaseOrderNo">{{record.purchaseOrderNo}}</a-tooltip></a>
      <span slot="createTime" slot-scope="text, record"><a-tooltip placement="topLeft" :title="record.createTime">{{ record.createTime }}</a-tooltip></span>
      <a slot="skuNum" slot-scope="text, record">{{record.totalQuantity}}</a>
    </a-table>
  </a-card>
</template>

<script>
import request from '../../../utils/request'

export default {
  name: 'ToInbound',
  computed: {
    toInboundColumn () {
      return [{
        dataIndex: 'purchaseOrderNo',
        title: this.$t('message.views.workbench.inboundOrderNo'),
        scopedSlots: { customRender: 'orderCode' },
        width: '45%',
        ellipsis: true
      }, {
        dataIndex: 'createTime',
        title: this.$t('message.views.workbench.orderTime'),
        scopedSlots: { customRender: 'createTime' },
        width: '45%',
        ellipsis: true
      },
      {
        align: 'right',
        title: this.$t('message.views.workbench.quantity'),
        dataIndex: 'totalQuantity',
        scopedSlots: { customRender: 'skuNum' },
        ellipsis: true
      }
      ]
    }
  },
  data () {
    return {
      toInboundData: [],
      toInboundPagination: {
        defaultPageSize: 5,
        current: 1,
        total: 0
      }
    }
  },
  methods: {
    getInboundOrders (pageData = {current: 1}) {
      this.toInboundPagination.current = pageData.current
      console.log('pageData:', pageData)
      let inboundOrderQueryVo = {
        inboundOrderNo: '',
        lbxOrderCode: '',
        warehouseId: '',
        orderStatusId: 30,
        platformId: '',
        cFromTime: '',
        cToTime: '',
        ids: ''
      }
      inboundOrderQueryVo.pageIndex = pageData.current
      inboundOrderQueryVo.pageSize = 10

      request({
        url: '/inboundOrder/queryInboundOrders',
        method: 'post',
        data: inboundOrderQueryVo
      }).then(response => {
        // response.data = json
        console.log('getInboundOrders', response)
        this.toInboundData = response.data.model
        this.toInboundPagination.total = response.data.totalCount
      })
    },
    showOrderDetail (record) {
      if (record.platform == 'AEG') {
        this.$router.push({name: 'inboundDetail', query: {purchaseLineData: record}})
      } else {
        this.$router.push({name: 'lzdinboundDetail', query: {purchaseLineData: record}})
      }
    }
  },
  mounted () {
    this.getInboundOrders()
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/Dashboard/components/ToInbound.vue